(function () {
  var BOUND_FLAG = '_hfMobileDrawerBound';
  var TRANSITION_FALLBACK_MS = 360;

  function isActiveViewport() {
    return !window.matchMedia('(min-width: 990px)').matches
      || !!(window.Shopify && window.Shopify.designMode);
  }

  function ensureOverlay() {
    var overlay = document.querySelector('.hf-mobile-menu-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'hf-mobile-menu-overlay';
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function bind(wrapper) {
    if (wrapper[BOUND_FLAG]) return;

    var details = document.querySelector('#Details-menu-drawer-container');
    var drawer = wrapper.querySelector('.hf-header-mobile-drawer-wrapper');
    if (!details || !drawer) return;

    wrapper[BOUND_FLAG] = true;
    var overlay = ensureOverlay();
    var transitionCleanup = null;

    function syncHeaderPosition() {
      var headerBottom = Math.round(wrapper.getBoundingClientRect().bottom);
      var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      wrapper.style.setProperty('--header-bottom-position', headerBottom + 'px');
      var available = vh - headerBottom - 24;
      drawer.style.maxHeight = (available > 0 ? available : 0) + 'px';
    }

    function clearTransitionCleanup() {
      if (!transitionCleanup) return;
      transitionCleanup();
      transitionCleanup = null;
    }

    function watchTransition(onDone) {
      clearTransitionCleanup();
      drawer.style.willChange = 'grid-template-rows';

      var fallback;
      var handler = function (event) {
        if (event && event.target !== drawer) return;
        if (event && event.propertyName !== 'grid-template-rows') return;
        finalize();
      };
      var finalize = function () {
        clearTimeout(fallback);
        drawer.removeEventListener('transitionend', handler);
        drawer.style.willChange = '';
        transitionCleanup = null;
        if (typeof onDone === 'function') onDone();
      };
      drawer.addEventListener('transitionend', handler);
      fallback = setTimeout(finalize, TRANSITION_FALLBACK_MS);
      transitionCleanup = finalize;
    }

    function openDrawer() {
      if (!isActiveViewport()) return;
      if (wrapper.dataset.hfDesktopDrawerOpen === 'true') return;
      syncHeaderPosition();
      watchTransition();
      wrapper.dataset.hfDesktopDrawerOpen = 'true';
      overlay.classList.add('hf-mobile-menu-overlay--active');
    }

    function closeDrawer() {
      if (!isActiveViewport()) return;
      if (!wrapper.dataset.hfDesktopDrawerOpen) return;
      watchTransition();
      delete wrapper.dataset.hfDesktopDrawerOpen;
      overlay.classList.remove('hf-mobile-menu-overlay--active');
    }

    var observer = new MutationObserver(function () {
      if (details.classList.contains('menu-opening')) {
        openDrawer();
      } else {
        closeDrawer();
      }
    });
    observer.observe(details, { attributes: true, attributeFilter: ['class'] });

    var resync = function () {
      if (wrapper.dataset.hfDesktopDrawerOpen === 'true') syncHeaderPosition();
    };
    window.addEventListener('resize', resync, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', resync, { passive: true });
    }

    function forceCloseMenu() {
      if (!details.classList.contains('menu-opening') && !details.hasAttribute('open')) return;
      var headerDrawer = wrapper.querySelector('header-drawer') || document.querySelector('header-drawer');
      var menuSummary = details.querySelector('summary');
      if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function' && menuSummary) {
        headerDrawer.closeMenuDrawer(new Event('click'), menuSummary);
        return;
      }
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      delete wrapper.dataset.hfDesktopDrawerOpen;
      overlay.classList.remove('hf-mobile-menu-overlay--active');
      var bp = (headerDrawer && headerDrawer.dataset && headerDrawer.dataset.breakpoint) || 'tablet';
      document.body.classList.remove('overflow-hidden-' + bp);
    }

    function watchSiblingModals() {
      document.querySelectorAll('details-modal').forEach(function (modal) {
        if (modal._hfMenuDismissBound) return;
        if (modal.closest('#Details-menu-drawer-container')) return;
        var modalDetails = modal.querySelector('details');
        if (!modalDetails) return;
        modal._hfMenuDismissBound = true;
        new MutationObserver(function () {
          if (!modalDetails.hasAttribute('open')) return;
          if (!isActiveViewport()) return;
          if (wrapper.dataset.hfDesktopDrawerOpen !== 'true' && !details.classList.contains('menu-opening')) return;
          forceCloseMenu();
        }).observe(modalDetails, { attributes: true, attributeFilter: ['open'] });
      });
    }
    watchSiblingModals();
    document.addEventListener('shopify:section:load', watchSiblingModals);

    function markReady() {
      if (drawer.hasAttribute('data-hf-pending')) drawer.removeAttribute('data-hf-pending');
    }
    function whenAllResourcesReady() {
      var fontsReady = (document.fonts && typeof document.fonts.ready !== 'undefined')
        ? document.fonts.ready
        : null;
      if (fontsReady && typeof fontsReady.then === 'function') {
        fontsReady.then(markReady, markReady);
      } else {
        markReady();
      }
    }
    if (document.readyState === 'complete') {
      whenAllResourcesReady();
    } else {
      window.addEventListener('load', whenAllResourcesReady, { once: true });
    }
    setTimeout(markReady, 3000);

    syncHeaderPosition();
    if (details.classList.contains('menu-opening')) openDrawer();
  }

  function init() {
    var wrapper = document.querySelector('.header-wrapper.hf-header-floating-shell');
    if (wrapper) bind(wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('.hf-header-floating-shell')) {
      init();
    }
  });
})();
